// Vendors
import React, { useEffect, useState } from 'react';

// Components
import { ProjectMessage } from '../index';

const ProjectMessages = ({
  IS_ADMIN,
  unreadMessages,
  showOnlyUnreadPM,
  setShowOnlyUnreadPM,
  projectMessages,
  loading,
  commentTabIDOpen,
  setCommentTabIDOpen,
  handleMarkAsRead,
  postNewMessage
}) => {
  const [messagesFilterUIDs, setMessagesFilterUIDs] = useState([]);
  const [filteredProjectMessages, setFilteredProjectMessages] = useState(null);
  const [filteredByBuilder, setFilteredByBuilder] = useState(0); // builder ID

  function getUnreadStatus(message) {
    if (IS_ADMIN) {
      return message.unread;
    } else {
      return message.new_comments > 0;
    }
  }

  useEffect(() => {
    if (projectMessages !== null && projectMessages.length > 0) {
      if (IS_ADMIN) {
        // For the 'Filter Projects by Builder' dropdown
        let builders = [];

        projectMessages.map((message) => {
          const alreadyExists = builders.findIndex(
            (builder) => builder.builder.ID === message.builder.ID
          );

          if (alreadyExists >= 0) {
            builders[alreadyExists].new_comments += parseInt(
              message.new_comments
            );
          } else {
            builders.push({
              builder: message.builder,
              new_comments: parseInt(message.new_comments)
            });
          }
        });

        builders.sort((a, b) =>
          a.builder['last_name'] < b.builder['last_name']
            ? -1
            : a.builder['last_name'] > b.builder['last_name']
            ? 1
            : 0
        );

        setMessagesFilterUIDs([...builders]);
      }

      if (showOnlyUnreadPM) {
        setFilteredProjectMessages([
          ...projectMessages.filter((message) => getUnreadStatus(message))
        ]);
      } else {
        setFilteredProjectMessages([...projectMessages]);
      }
    }
  }, [projectMessages]);

  useEffect(() => {
    if (projectMessages === null) return;

    let filteredData = [...projectMessages];

    if (IS_ADMIN) {
      if (filteredByBuilder) {
        filteredData = filteredData.filter(
          ({ builder }) => builder.ID === filteredByBuilder
        );
      }
    }

    if (showOnlyUnreadPM) {
      setFilteredProjectMessages([
        ...filteredData.filter((message) => getUnreadStatus(message))
      ]);
    } else {
      setFilteredProjectMessages([...filteredData]);
    }
  }, [filteredByBuilder, showOnlyUnreadPM]);

  if (projectMessages === null || filteredProjectMessages === null)
    return 'No Project Messages.';

  return (
    <>
      <div className="project-messages__filters">
        {IS_ADMIN && (
          <div className="form__select form__select--lg form__input--no-shadow u--margin-bottom-30 ">
            <select
              name="filter_by_builder"
              className="form__input form__input--lg"
              defaultValue=""
              onChange={(event) =>
                setFilteredByBuilder(event.currentTarget.value)
              }
            >
              <option value="">-- Filter Projects by Builder --</option>
              {messagesFilterUIDs.map(
                (
                  {
                    new_comments,
                    builder: { ID, first_name, last_name, user_email, company }
                  },
                  index
                ) => (
                  <option key={`${index}-${ID}`} value={ID}>
                    {last_name && last_name}
                    {first_name && `, ${first_name}`} ({user_email})
                    {company && ` - ${company}`}
                    {new_comments > 0 && ` - (${new_comments} unread)`}
                  </option>
                )
              )}
            </select>
          </div>
        )}
        <div className="form__field messages__unread-checkbox">
          <label
            className={`form__checkbox ${
              unreadMessages.project === 0 ? 'form__checkbox--disabled' : ''
            }`}
            htmlFor="show_only_unread_pms"
          >
            Show only unread messages.{' '}
            <input
              id="show_only_unread_pms"
              type="checkbox"
              name="show_only_unread_pms"
              checked={showOnlyUnreadPM}
              onChange={() => setShowOnlyUnreadPM(!showOnlyUnreadPM)}
              disabled={unreadMessages.project === 0}
            />
          </label>
        </div>
      </div>
      {Object.values(filteredProjectMessages).length > 0
        ? Object.values(
            filteredProjectMessages
          ).map(
            (
              { messages, builder, permalink, pid, title, new_comments },
              index
            ) => (
              <ProjectMessage
                key={`${index}-${pid}`}
                IS_ADMIN={IS_ADMIN}
                messages={messages}
                builder={IS_ADMIN ? builder : { uid: 0, display_name: null }}
                url={permalink}
                pid={pid}
                title={title}
                new_comments={new_comments}
                loading={loading}
                commentTabIDOpen={commentTabIDOpen}
                setCommentTabIDOpen={setCommentTabIDOpen}
                handleMarkAsRead={handleMarkAsRead}
                postNewMessage={postNewMessage}
              />
            )
          )
        : 'No Project Messages.'}
    </>
  );
};
export default ProjectMessages;
